/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Preferred_Voice_DescriptionInputs */

const en_settings_v2_preferred_voice_description = /** @type {(inputs: Settings_V2_Preferred_Voice_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used for every new conversion. You can override it per document.`)
};

const es_settings_v2_preferred_voice_description = /** @type {(inputs: Settings_V2_Preferred_Voice_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se usa en cada conversión nueva. Puedes cambiarla por documento.`)
};

/**
* | output |
* | --- |
* | "Used for every new conversion. You can override it per document." |
*
* @param {Settings_V2_Preferred_Voice_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_preferred_voice_description = /** @type {((inputs?: Settings_V2_Preferred_Voice_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Preferred_Voice_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_preferred_voice_description(inputs)
	return en_settings_v2_preferred_voice_description(inputs)
});